<template lang="pug">
    div
        Button(
            @click="getAlertRuleLogs" 
            shape="circle"
            icon="ios-list-box-outline"
        )
        Modal(
            :title="ruleData.ruleName + ' logs'"
            v-model="showModal"
            width="1200"
        )
            Select(v-model="selectedDate" @on-change="getAlertRuleLogs")
                Option(
                    v-for="(dateOption, index) in dateOptions" 
                    :label="dateOption.label" 
                    :value="dateOption.value"
                    :key="index"
                )

            virtual-table(
                    :data="tableData"
                    :columns="tableColumns"
                    :minWidth="1000"
                    :withSelectAllBtn="false"
                    )
</template>

<script>
import { _getAlertRuleLogs } from "@/api/monitor";
import { _dateFormat } from "@/libs/dateformat";
import VirtualTable from "@/components/VirtualTable";

export default {
    name: "RuleTestBtn",
    components: {
        VirtualTable
    },
    data() {
        return {
            selectedDate: _dateFormat(new Date(), "YYYY.MM.DD"),
            isLoading: false,
            showModal: false,
            tableColumns: [
                { title: "Timestamp", key: "timestamp"},
                // { title: "ruleName", key: "ruleName" },
                { title: "Alerting", key: "isAlerting", sortable: true },
                { title: "Test Value", key: "currentValue", sortable: true },
                { title: "Alert When", key: "alertWhen", sortable: true },
                { title: "Alert Value", key: "alertValue", sortable: true },
                { title: "Unit", key: "alertValueUnit", sortable: true }
            ],

            tableData: []
        };
    },
    props: { ruleData: {} },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        getAlertRuleLogs() {
            var self = this;
            this.showModal = true;
            this.isLoading = true;
            _getAlertRuleLogs({
                groupName: this.ruleData.groupName,
                ruleName: this.ruleData.ruleName,
                dateTime: this.selectedDate
            })
                .then(res => {
                    self.tableData = res.data.data.map(e => {
                        e.timestamp = new Date(e.timestamp).toLocaleString();
                        return e;
                    });
                    self.isLoading = false;
                })
                .catch(err => {
                    self.isLoading = false;
                    self.showModal = false;
                    console.log(err);
                    self.$Notice.warning({
                        title: "Failed",
                        desc: `${err.message}`
                    });
                });
        }
    },
    computed: {
        dateOptions() {
            let options = [];
            for (let i = 0; i < 7; i++) {
                let d = new Date();
                let dateTime = _dateFormat(
                    new Date(d.setDate(d.getDate() - i)),
                    "YYYY.MM.DD"
                );
                options.push({
                    label: dateTime,
                    value: dateTime
                });
                options[0].label = "Today";
            }
            return options;
        }
    },
    beforeDestroy() {}
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/AlertRules/ViewLogsBtn.vue